/* eslint-disable max-len */
import React from 'react';

const TwitterIcon = () => (
  <svg className="twitter-icon" viewBox="0 0 490.85 398.84">
    <path d="M444.76,153.78c.29,4.32.29,8.66.29,13,0,133.08-101.31,286.54-286.54,286.54v-.08A285.1,285.1,0,0,1,4.15,408.09a204.43,204.43,0,0,0,24,1.46,202.08,202.08,0,0,0,125.06-43.2,100.82,100.82,0,0,1-94.08-69.93,100.68,100.68,0,0,0,45.47-1.73A100.73,100.73,0,0,1,23.79,196v-1.28A100,100,0,0,0,69.5,207.3,100.77,100.77,0,0,1,38.32,72.87,285.89,285.89,0,0,0,245.87,178.08,100.8,100.8,0,0,1,417.49,86.24a201.91,201.91,0,0,0,63.94-24.45,101,101,0,0,1-44.27,55.7A201.19,201.19,0,0,0,495,101.65,204.94,204.94,0,0,1,444.76,153.78Z" transform="translate(-4.15 -54.49)"/>
  </svg>
);

export default TwitterIcon;
